import "core-js/modules/es6.array.map";
import o from "react";
import { SitemapLinks as r } from "./SitemapLinks";

var t = function t(_ref) {
  var e = _ref.sitemapGroups;
  return e ? o.createElement("nav", {
    className: "hg-global-footer__sitemap-footer",
    "aria-label": "Footer Navigation"
  }, o.createElement("ul", {
    className: "hg-global-footer__sitemap-items"
  }, e.map(function (a) {
    return o.createElement("li", {
      key: a.groupName,
      id: a.groupName
    }, o.createElement("div", {
      className: "hg-global-footer__sitemap-label"
    }, a.groupLabel), o.createElement(r, {
      sitemapLinks: a.sitemapLinks
    }));
  }))) : null;
};

export { t as SitemapFooter };